/* eslint no-console: 1 */
import Axios from 'axios'
import { decodeJwt } from 'jose'
import store from '../store'

const baseService = {
	baseURL() {
		return `${import.meta.env.VITE_APP_API_URL}` // `${process.env.VUE_APP_BASE_URL}`;//`${process.env.VUE_APP_BASE_URL}`;//'https://www.fierydevelopment.com:811/api/';
	},
	formURL(url: string) {
		return this.baseURL() + url
	},
	generateConfigData() {
		if (store.getters.getCurrentUser) {
			const target_copy: any = Object.assign({}, store.getters.getCurrentUser)
			return {
				baseURL: this.baseURL(),
				timeout: 100000,
				headers: {
					'content-type': 'application/json',
					Authorization: `Bearer ${target_copy.accessToken}`
				}
			}
		} else {
			return {
				baseURL: this.baseURL(),
				timeout: 100000,
				headers: {
					'content-type': 'application/json'
				}
			}
		}
	},

	async processRequest(endpoint: string, data: any) {
		try {
			decodeJwt(store.getters.getCurrentUser.token)
			//console.log(jwtObject)
			const d = new Date()
			if (d > store.getters.user.expires) {
				/// redirect and sign user out.
			}
			return await Axios.post(
				baseService.formURL(endpoint),
				data,
				baseService.generateConfigData()
			).catch(async function (error) {
				if (error.response) {
					if (error.response.status === 401) {
						return await Axios.post(
							baseService.formURL(endpoint),
							data,
							baseService.generateConfigData()
						)
					}
				}
			})
		} catch (error: any) {
			if (error.toString().includes('401')) {
				//await baseService.refreshAccessToken()
				//return await Axios.post(baseService.formURL(endpoint), data, baseService.generateConfigData())
			} // else if (error.toString().includes('403')) {
			//   console.log(error.toString().substr(error.toString().indexOf('('), error.toString().indexOf(')') + 1))
			// }
		}
	}
}

export default baseService
